module.exports = __webpack_public_path__ + "img/IMG_0341.f82e2fd4.png";